
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tc-renter",
      function () {
        return require("private-next-pages/tc-renter.js");
      }
    ]);
  